import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { ManualsDownloadedNeverConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "manuals-downloaded-never-details",
  templateUrl: "./manuals-downloaded-never-details.component.html",
  standalone: false,
})
export class ManualsDownloadedNeverDetailsComponent
  extends BaseDetailsLogic<ManualsDownloadedNeverConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(
      analyticsService,
      authService,
      loggingService,
      ManualsDownloadedNeverConfig,
      tooltipCoordinator
    );
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedNumberResults(): number {
    return this.config?.numberResults;
  }

  set selectedNumberResults(value: number) {
    this.config.numberResults = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see which manuals have never been downloaded during that time. For example, you can look at manuals that were never downloaded in the last month or year. This helps you find manuals that might need more attention or updates so people will use them.",
      numberResults:
        "Set how many items you want to see in the list. For example, if you enter 10, you will see the top 10 items. This helps you focus on the most or least popular items, depending on the chart.",
    };
  }
}
